import React from 'react';

import { StickyHeaderLinksBlockData } from 'api/cms';
import { PrimaryButtonRouterLink } from 'components/Button';
import { isEmpty } from 'utils/functional';
import { isUrlWithProtocol } from 'utils/url';

import { StickyHeaderLinks } from './StickyHeaderLinks';
import { StickyHeaderLinksBlockExternalLink } from './StickyHeaderLinksBlockExternalLink';

type Props = {
  data: StickyHeaderLinksBlockData;
};

export function StickyHeaderLinksBlock({
  data: { links, buttonText, buttonUrl },
}: Props) {
  const hasButton = !isEmpty(buttonUrl) && !isEmpty(buttonText);
  return (
    <StickyHeaderLinks
      links={links}
      button={
        hasButton &&
        (buttonUrl && isUrlWithProtocol(buttonUrl) ? (
          <StickyHeaderLinksBlockExternalLink href={buttonUrl}>
            {buttonText}
          </StickyHeaderLinksBlockExternalLink>
        ) : (
          <PrimaryButtonRouterLink to={buttonUrl}>
            {buttonText}
          </PrimaryButtonRouterLink>
        ))
      }
    />
  );
}
